// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"page-title_pageTitle__frdrE","title":"page-title_title__DLzCP","subtitle":"page-title_subtitle__IocD8"};